module.exports = __webpack_public_path__ + "img/reserved.084e1bd7.png";